import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NoSchedules() {
  const LocalBasePath = "page.candidate.dashboard.UnscheduledReader";
  const { t, i18n } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <div className="flex flex-col items-center p-16">
      <h2 className="text-gray-700 mb-1 text-[18px] font-medium">
        {t(`welcomeToSanadLetsStartYourEducationalJourney`)}
      </h2>
      <p className="text-gray-500 text-[14px] font-normal">
        {t(`toBeginYourEducationalJourneyLetsCreateYourWeeklyScheduleNow`)}
      </p>
      <Link
        to={"/student/proposed-schedule"}
        className="bg-brandblue-600 text-white px-[15px] py-[9px] rounded-md my-6"
      >
        {t(`createTheWeeklySchedule`)}
      </Link>
      <a
        target="_blank"
        href={
          i18n.language === "ar"
            ? "https://www.sanadquran.com/ar/privacy-policy-2/"
            : "https://www.sanadquran.com/en/privacy-policy-2/"
        }
        className="text-brandblue-600 "
      >
        {t(`readingRoomEtiquette`)}
      </a>
    </div>
  );
}
